<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up convocatorias-shell" flat>
          <v-card-text>
            <v-container fluid>
              <v-row justify="end" align="center">
                <v-col cols="12" md="auto" class="pr-md-1">
                  <TextButton
                    rounded
                    color="secondary"
                    class="ui-module-btn-solid"
                    @click="openRegistrarConvocatoriaDialog"
                  >
                    Registrar convocatoria
                  </TextButton>
                </v-col>
                <v-col cols="12" md="3" class="pl-md-1">
                  <v-text-field
                    v-model="buscaConvocatoria"
                    class="ui-form-field"
                    rounded
                    filled
                    dense
                    hide-details
                    color="secondary"
                    background-color="transparent"
                    label="Buscar convocatoria"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn class="primary secondary--text ui-module-icon-action" elevation="8" icon @click="downloadConvocatoriasCsv"><v-icon>mdi-download</v-icon></v-btn>
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="transparent ui-module-table"
                    :headers="headers"
                    :items="convocatorias"
                    :search="buscaConvocatoria"
                    :loading="loading"
                    loading-text="Cargando convocatorias..."
                    dense
                    calculate-widths
                    show-expand
                    :expanded.sync="expanded"
                  >
                    <!-- Columnas principales visibles -->
                    <template v-slot:[`item.fechaHoraPublicacionConvocatoria`]="{ item }">
                      {{ formatDate(item.fechaHoraPublicacionConvocatoria) }}
                    </template>
                    <template v-slot:[`item.fechaHoraInicioRegistro`]="{ item }">
                      {{ formatDate(item.fechaHoraInicioRegistro) }}
                    </template>
                    <template v-slot:[`item.fechaHoraCierreRegistro`]="{ item }">
                      {{ formatDate(item.fechaHoraCierreRegistro) }}
                    </template>
                    <template v-slot:[`item.fechaHoraResultados`]="{ item }">
                      {{ formatDate(item.fechaHoraResultados) }}
                    </template>

                    <!-- Panel expandido con detalles adicionales -->
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <div class="expanded-detail-panel">
                          <v-row dense>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Beneficios</div>
                              <div class="text-body-2 detail-value">{{ item.beneficios || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Requisitos</div>
                              <div class="text-body-2 detail-value">{{ item.requisitos || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Documentación</div>
                              <div class="text-body-2 detail-value">{{ item.documentacion || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Lugar de recepción</div>
                              <div class="text-body-2 detail-value">{{ item.lugarRecepcionDocumentos || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Fecha de recepción</div>
                              <div class="text-body-2 detail-value">
                                {{ formatDate(item.fechaHoraRecepcionDocumentos) }}
                              </div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">
                                Procedimiento de selección
                              </div>
                              <div class="text-body-2 detail-value">{{ item.procedimientoSeleccion || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Dirigido a</div>
                              <div class="text-body-2 detail-value">{{ item.catDirigido?.title || '-' }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="text-subtitle-2 font-weight-bold detail-label">Grado a promocionar</div>
                              <div class="text-body-2 detail-value">{{ item.catGradoPromocion?.title || '-' }}</div>
                            </v-col>
                          </v-row>
                        </div>
                      </td>
                    </template>

                    <!-- Columna de opciones -->
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="primary secondary--text ui-module-icon-action mr-2"
                              elevation="8"
                              icon
                              v-bind="attrs"
                              v-on="on"
                              :loading="loadingEditarConvocatoria === item.id"
                              @click="openEditarConvocatoriaDialog(item)"
                            ><v-icon>mdi-pencil</v-icon></v-btn>
                          </template>
                          <span>Editar convocatoria</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="primary secondary--text ui-module-icon-action mr-2"
                              elevation="8"
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="openPersonalVinculadoDialog(item)"
                            ><v-icon>mdi-account-multiple</v-icon></v-btn>
                          </template>
                          <span>Ver personal vinculado</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-btn
                                class="primary secondary--text ui-module-icon-action mr-2"
                                elevation="8"
                                icon
                                :disabled="!item.urlAdjunto"
                                @click="downloadAdjunto(item)"
                              ><v-icon>mdi-download</v-icon></v-btn>
                            </span>
                          </template>
                          <span>{{ item.urlAdjunto ? 'Descargar adjunto' : 'Sin adjunto' }}</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                elevation="8"
                                variant="secondary"
                                icon="mdi-account-multiple-plus"
                                @click="openAsignarPersonalDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Asignar personal manualmente</span>
                        </v-tooltip> -->
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TextButton from '../../components/base/TextButton.vue'
import IconButton from '@/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import moment from 'moment'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    TextButton,
    IconButton,
  },

  data() {
    return {
      buscaConvocatoria: '',
      loading: false,
      loadingEditarConvocatoria: false,
      expanded: [],
      // Solo las 8 columnas más importantes + opciones
      headers: [
        { text: 'Convocatoria', value: 'convocatoria', align: 'left' },
        { text: 'Plazas', value: 'plazasVacantes', align: 'center' },
        { text: 'Fecha Publicación', value: 'fechaHoraPublicacionConvocatoria', align: 'left' },
        { text: 'Fecha Inicio', value: 'fechaHoraInicioRegistro', align: 'left' },
        { text: 'Fecha Cierre', value: 'fechaHoraCierreRegistro', align: 'left' },
        { text: 'Fecha Resultados', value: 'fechaHoraResultados', align: 'left' },
        { text: 'SubTipo', value: 'catSubTipoConvocatoria.title', align: 'left' },
        { text: 'Tipo', value: 'catSubTipoConvocatoria.catTipoConvocatoria.title', align: 'left' },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },

  computed: {
    ...mapGetters('convocatorias', {
      convocatorias: 'getConvocatorias',
    }),
    filteredConvocatorias() {
      const term = (this.buscaConvocatoria || '').trim().toLowerCase()
      if (!term) return this.convocatorias || []
      return (this.convocatorias || []).filter(
        (c) =>
          (c.convocatoria || '').toLowerCase().includes(term) ||
          (c.catSubTipoConvocatoria?.title || '').toLowerCase().includes(term) ||
          (c.catSubTipoConvocatoria?.catTipoConvocatoria?.title || '').toLowerCase().includes(term)
      )
    },
  },

  async mounted() {
    await this.loadConvocatorias()
  },

  methods: {
    ...mapActions('convocatorias', ['fetchAllConvocatorias']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    async loadConvocatorias() {
      try {
        this.loading = true
        await this.fetchAllConvocatorias()
      } catch (error) {
        console.error('Error al cargar las convocatorias:', error)
        this.$store.commit('SET_SNACKBAR_MESSAGE', 'Error al cargar las convocatorias')
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      if (!date) return '-'

      if (typeof date === 'string' && (date.includes('a. m.') || date.includes('p. m.'))) {
        const datePart = date.split(' ')[0]
        const parsedDate = moment(datePart, 'DD/MM/YYYY', true)
        return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '-'
      }

      const parsedDate = moment(date)
      return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : '-'
    },

    openRegistrarConvocatoriaDialog() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_CONVOCATORIA)
    },

    async openEditarConvocatoriaDialog(convocatoria) {
      this.loadingEditarConvocatoria = convocatoria.id
      await this.$nextTick()
      this.loadingEditarConvocatoria = false
      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
      })
    },

    openPersonalVinculadoDialog(convocatoria) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.PERSONAL_VINCULADO_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
      })
    },

    downloadAdjunto(convocatoria) {
      if (!convocatoria.urlAdjunto) return
      window.open(convocatoria.urlAdjunto, '_blank', 'noopener,noreferrer')
    },

    openAsignarPersonalDialog(convocatoria) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.ASIGNAR_PERSONAL_MANUALMENTE_CONVOCATORIA,
        props: {
          convocatoriaData: convocatoria,
        },
        listeners: {
          'personal-added': async () => {
            await this.loadConvocatorias()
          },
        },
      })
    },

    downloadConvocatoriasCsv() {
      const rows = (this.filteredConvocatorias || []).map((item) => ({
        Convocatoria: item.convocatoria || '',
        'Plazas Vacantes': item.plazasVacantes || '',
        'Fecha Publicación': this.formatDate(item.fechaHoraPublicacionConvocatoria),
        'Fecha Inicio Registro': this.formatDate(item.fechaHoraInicioRegistro),
        'Fecha Cierre Registro': this.formatDate(item.fechaHoraCierreRegistro),
        'Fecha Resultados': this.formatDate(item.fechaHoraResultados),
        'Fecha Recepción Documentos': this.formatDate(item.fechaHoraRecepcionDocumentos),
        SubTipo: item.catSubTipoConvocatoria?.title || '',
        Tipo: item.catSubTipoConvocatoria?.catTipoConvocatoria?.title || '',
        'Dirigido a': item.catDirigido?.title || '',
        'Grado a Promocionar': item.catGradoPromocion?.title || '',
        Beneficios: item.beneficios || '',
        Requisitos: item.requisitos || '',
        Documentación: item.documentacion || '',
        'Lugar Recepción': item.lugarRecepcionDocumentos || '',
        'Procedimiento Selección': item.procedimientoSeleccion || '',
      }))

      downloadCsv(rows, { filename: 'convocatorias' })
    },
  },
}
</script>
<style scoped>
/* Tooltips con colores dinámicos */
::v-deep .v-tooltip__content {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.95) !important;
  color: #1a1a1a !important;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
}

/* Botones con efectos modernos */
::v-deep .v-btn {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

::v-deep .v-btn:active {
  transform: translateY(0);
}

::v-deep .ui-form-field .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

.expanded-detail-panel {
  background: rgba(12, 19, 24, 0.46);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.18);
  border-radius: 14px;
  padding: 16px;
}

.detail-label {
  color: rgba(224, 224, 224, 0.72) !important;
}

.detail-value {
  color: #e9f4ff !important;
}

::v-deep .v-btn.v-btn--icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn.v-btn--icon:hover {
  transform: scale(1.2) rotate(5deg);
}

/* Card loading overlay */
::v-deep .v-card__progress {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-card__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

.convocatorias-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .convocatorias-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .convocatorias-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
